// app/javascript/controllers/tweet_calendar_controller.js
import { Controller } from "@hotwired/stimulus"

// Minimal controller for tweet calendar interactions.
// Currently handles tooltip-like hover state; future: month navigation via AJAX.
export default class extends Controller {
  connect() {
    // Calendar is server-rendered; this controller is a hook for future interactivity
  }
}
